"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationChanel = void 0;
const topic_1 = require("../../topic");
const action_1 = require("../../action");
const NAVIGATION_CHANNEL = 'navigation';
class PerformActionTopic extends topic_1.Topic {
    constructor(getPerformActionChannel, getNavigationChannel, _logger) {
        super('performAction', NAVIGATION_CHANNEL, _logger);
        this.getPerformActionChannel = getPerformActionChannel;
        this.getNavigationChannel = getNavigationChannel;
        this._logger = _logger;
    }
    publish(headers, payload) {
        let actionId = payload.actionID.toString();
        if (actionId === 'OPEN_BANKING') {
            actionId = 'openBanking';
        }
        else if (actionId === 'UPLOAD_DOCUMENTS') {
            actionId = 'uploadDocumentsFromCashier';
        }
        const topicName = actionId;
        const performActionTopic = this.getPerformActionChannel().topics[topicName];
        if (performActionTopic && performActionTopic.hasRegisteredResolver) {
            const pload = {
                actionData: payload.actionData,
                correlationID: payload.correlationID,
                launchInfo: payload.launchInfo,
            };
            performActionTopic.execute(pload).then((response) => {
                if (response) {
                    this.getNavigationChannel().topics.performActionResult.publish(headers, {
                        actionID: payload.actionID,
                        actionData: payload.actionData,
                        correlationID: payload.correlationID,
                        resultData: response,
                    });
                }
            });
        }
        else {
            super.publish(headers, payload);
            this._logger.warn(`Publishing a performAction of Action: ${actionId} via navigation channel is deprecated,
                use performAction channel and registeredResolver instead.`);
        }
    }
}
class NavigationChanel {
    constructor(getPerformActionChannel, _logger) {
        this.getPerformActionChannel = getPerformActionChannel;
        this._logger = _logger;
        this.channel = NAVIGATION_CHANNEL;
        this.topics = {
            openApp: new topic_1.Topic('openApp', NAVIGATION_CHANNEL, this._logger),
            openAppPending: new topic_1.Topic('openAppPending', NAVIGATION_CHANNEL, this._logger),
            overlayClicked: new topic_1.Topic('overlayClicked', NAVIGATION_CHANNEL, this._logger),
            changeBrowserURI: new topic_1.Topic('changeBrowserURI', NAVIGATION_CHANNEL, this._logger),
            Deactivate: new topic_1.Topic('Deactivate', NAVIGATION_CHANNEL, this._logger),
            Navigate: new topic_1.Topic('Navigate', NAVIGATION_CHANNEL, this._logger),
            performAction: new PerformActionTopic(this.getPerformActionChannel, () => this, this._logger),
            performActionResult: new topic_1.Topic('performActionResult', NAVIGATION_CHANNEL, this._logger),
            scrollToGame: new topic_1.Topic('scrollToGame', NAVIGATION_CHANNEL, this._logger),
            flowRunner: new topic_1.Topic('flowRunner', NAVIGATION_CHANNEL, this._logger),
            openClientPage: new topic_1.Topic('openClientPage', NAVIGATION_CHANNEL, this._logger),
            redirectOrNativeOpenExternalUrl: new topic_1.Topic('redirectOrNativeOpenExternalUrl', NAVIGATION_CHANNEL, this._logger),
            actionInterrupted: new topic_1.Topic('actionInterrupted', NAVIGATION_CHANNEL, this._logger),
            updateApp: new action_1.Action('updateApp', NAVIGATION_CHANNEL, this._logger),
        };
    }
}
exports.NavigationChanel = NavigationChanel;
//# sourceMappingURL=navigation.channel.js.map